/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateRoleAssignmentError } from './UpdateRoleAssignmentError';
import {
    UpdateRoleAssignmentErrorFromJSON,
    UpdateRoleAssignmentErrorFromJSONTyped,
    UpdateRoleAssignmentErrorToJSON,
    UpdateRoleAssignmentErrorToJSONTyped,
} from './UpdateRoleAssignmentError';

/**
 * 
 * @export
 * @interface UpdateRoleAssignmentsResponse
 */
export interface UpdateRoleAssignmentsResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateRoleAssignmentsResponse
     */
    addedRoleAssignmentsCount: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRoleAssignmentsResponse
     */
    removedRoleAssignmentsCount: number;
    /**
     * 
     * @type {Array<UpdateRoleAssignmentError>}
     * @memberof UpdateRoleAssignmentsResponse
     */
    errors: Array<UpdateRoleAssignmentError>;
}

/**
 * Check if a given object implements the UpdateRoleAssignmentsResponse interface.
 */
export function instanceOfUpdateRoleAssignmentsResponse(value: object): value is UpdateRoleAssignmentsResponse {
    if (!('addedRoleAssignmentsCount' in value) || value['addedRoleAssignmentsCount'] === undefined) return false;
    if (!('removedRoleAssignmentsCount' in value) || value['removedRoleAssignmentsCount'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    return true;
}

export function UpdateRoleAssignmentsResponseFromJSON(json: any): UpdateRoleAssignmentsResponse {
    return UpdateRoleAssignmentsResponseFromJSONTyped(json, false);
}

export function UpdateRoleAssignmentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRoleAssignmentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'addedRoleAssignmentsCount': json['addedRoleAssignmentsCount'],
        'removedRoleAssignmentsCount': json['removedRoleAssignmentsCount'],
        'errors': ((json['errors'] as Array<any>).map(UpdateRoleAssignmentErrorFromJSON)),
    };
}

export function UpdateRoleAssignmentsResponseToJSON(json: any): UpdateRoleAssignmentsResponse {
    return UpdateRoleAssignmentsResponseToJSONTyped(json, false);
}

export function UpdateRoleAssignmentsResponseToJSONTyped(value?: UpdateRoleAssignmentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addedRoleAssignmentsCount': value['addedRoleAssignmentsCount'],
        'removedRoleAssignmentsCount': value['removedRoleAssignmentsCount'],
        'errors': ((value['errors'] as Array<any>).map(UpdateRoleAssignmentErrorToJSON)),
    };
}

